import { Typography, Box, useTheme } from '@mui/material';
import GaugeChart from 'react-gauge-chart';
import { tokens } from '../theme';

const getScoreColor = (score, colors) => {
  if (score < 301) return '#ff5050';
  if (score < 701) return '#ed6c02';
  return colors.greenAccent[600];
};

const CreditAnalysisSection = ({
  score = 0,
  riskPercentage = 0,
  scoreLabel = 'Agroscore',
  riskLabel = 'Probabilidade de risco',
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const scoreColor = getScoreColor(score, colors);
  const riskColor = riskPercentage > 5 ? '#c62828' : colors.greenAccent[600];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 1 }}>
      <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#6b7280', mb: 0.5 }}>
        {scoreLabel}
      </Typography>
      <Box sx={{ width: '100%', maxWidth: 280 }}>
        <GaugeChart
          id={`gauge-score-${score}`}
          nrOfLevels={20}
          percent={score / 1000}
          arcWidth={0.2}
          hideText
          colors={['#ff5050', '#fff28b', colors.greenAccent[500]]}
        />
      </Box>

      <Typography sx={{ fontSize: '32px', fontWeight: 800, color: scoreColor, lineHeight: 1 }}>
        {Math.floor(score)}
        <Box component="span" sx={{ fontSize: '16px', fontWeight: 500, color: '#6b7280', ml: 0.75 }}>
          de 1000
        </Box>
      </Typography>

      <Typography sx={{ fontSize: '13px', mt: 1.5, fontWeight: 600, display: 'flex', gap: '4px' }}>
        {riskLabel}: 
        <Typography 
          sx={{  color: riskColor }}
        >
          {riskPercentage.toFixed(2)}%
        </Typography>
      </Typography>

      <Box 
        sx={{ 
          display: 'flex', 
          gap: 2, 
          mt: 2, 
          flexWrap: 'wrap', 
          justifyContent: 'center', 
          paddingX: '12px' 
          }}
        >
        {[
          { color: '#ff5050', label: 'Baixo (0-300)' },
          { color: '#ed6c02', label: 'Médio (301-700)' },
          { color: colors.greenAccent[500], label: 'Alto (701-1000)' },
        ].map(({ color, label }) => (
          <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: color }} />
            <Typography sx={{ fontSize: '11px', color: '#6b7280' }}>{label}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CreditAnalysisSection;
